import { servicesCompanyData, servicesData } from "@/constants/Services"
import SingleService from "./SingleService"
import ScrollFadeIn from "@/components/shared/animations/ScrollFadeIn"

const Services = ({ serviceType }: {
    serviceType: string
}) => {
    const services = serviceType === 'people' ? servicesData : servicesCompanyData;

    return (
        <div className="w-full px-4 md:px-10 lg:px-0">
            <div className="flex flex-col space-y-16 md:space-y-36">
                {services?.map((service, index) => (
                    <ScrollFadeIn key={index}>
                        <SingleService service={service} />
                    </ScrollFadeIn>
                ))}
            </div>
        </div>
    )
}

export default Services